export default "__VITE_ASSET__AOdVDuKu__"